import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const editorToolbarPluginKey = new PluginKey('editorToolbarPluginKey');
